import { render, staticRenderFns } from "./CustomizableTable.vue?vue&type=template&id=21d1b372&scoped=true"
import script from "./CustomizableTable.vue?vue&type=script&lang=js"
export * from "./CustomizableTable.vue?vue&type=script&lang=js"
import style0 from "./CustomizableTable.vue?vue&type=style&index=0&id=21d1b372&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d1b372",
  null
  
)

export default component.exports